/**
 * Guest checkout grant storage — survives hard refresh mid plan/delivery/payment.
 * Keyed by assessmentId; never logged (capability token).
 */
const keyFor = (assessmentId: string) => `gps.checkoutToken.${assessmentId}`;

export function readCheckoutToken(assessmentId: string): string | undefined {
  try {
    const v = sessionStorage.getItem(keyFor(assessmentId));
    return v && v.length > 0 ? v : undefined;
  } catch {
    return undefined;
  }
}

export function writeCheckoutToken(assessmentId: string, token: string): void {
  try {
    sessionStorage.setItem(keyFor(assessmentId), token);
  } catch {
    /* private mode — in-memory prop still works for the session */
  }
}

export function clearCheckoutToken(assessmentId: string): void {
  try {
    sessionStorage.removeItem(keyFor(assessmentId));
  } catch {
    /* ignore */
  }
}
